import { VersionHistoryList } from '@dataroom/shared';
import { useDocumentVersions } from '@/api/hooks';

/**
 * The seller's VERSION HISTORY of one document (ADR-0031): every version with
 * Open / Download. Read-only — splitting a merge back out is the room admin's.
 */
export function SellerVersionHistory({
  roomId,
  documentId,
}: {
  roomId: string;
  documentId: string;
}) {
  const versions = useDocumentVersions(roomId, documentId);
  return (
    <VersionHistoryList
      roomId={roomId}
      documentId={documentId}
      versions={versions.data}
      error={versions.error}
    />
  );
}
